import React from "react";
import { ShieldIcon } from "../../../Icons";
import { insuranceApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage, {
  cellMuted,
} from "../components/LibraryCatalogPage";
import InsuranceFormModal from "./InsuranceFormModal";

const columns = [
  {
    header: "Insurance Name",
    accessor: "insuranceName",
    sortable: true,
    strong: true,
    className: "whitespace-nowrap px-3 min-w-[10rem]",
  },
  { header: "Category", accessor: "category", sortable: true },
  {
    header: "Insurance Code",
    accessor: "insuranceCode",
    sortable: true,
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>
        {row.insuranceCode || "—"}
      </span>
    ),
  },
];

const InsuranceCarriersPage = () => (
  <LibraryCatalogPage
    title="Insurance Carriers"
    icon={ShieldIcon}
    addLabel="Create New"
    searchPlaceholder="Search by name, category, code..."
    entityLabel="Insurance"
    defaultSortBy="insuranceName"
    api={insuranceApi}
    columns={columns}
    FormModal={InsuranceFormModal}
    getDeleteLabel={(row) => row.insuranceName}
  />
);

export default InsuranceCarriersPage;
